import { AxiosMethods, OrdersApi } from '../../../../enums';
import { axiosHelper } from '../../../axios-instance';

export enum OrderMutationsKey {
  DELETE_ORDER = 'delete_order'
}

export const deleteOrderMutation = () => ({
  mutationFn: ({ orderId }: { orderId: string }) =>
    axiosHelper({
      endpoint: OrdersApi.deleteOrder.replace(':orderId', orderId),
      method: AxiosMethods.DELETE,
      baseURL: process.env.REVOPS_API
    })
});
